import React from 'react';
import { motion, useScroll, useSpring } from 'framer-motion';
export function ScrollProgress() {
  const {
    scrollYProgress
  } = useScroll();
  const scaleX = useSpring(scrollYProgress, {
    stiffness: 100,
    damping: 30,
    restDelta: 0.001
  });
  return <div className="fixed top-0 left-0 right-0 z-50" data-id="element-138">
      <motion.div className="h-1 bg-red-600 origin-left" style={{
      scaleX
    }} data-id="element-139" />
    </div>;
}